import styled from 'styled-components';

export const PopupBackground = styled.section`
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
`;
export const Popup = styled.div`
  background: white;
  border-radius: 1rem;
  position: relative;
  &.small { width: 30rem}
  &.medium { width: 50rem; text-align: left; }
  &.large { width: 90rem}
`;
export const PopupHeader = styled.div(
  props => `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 2rem;
    border-bottom: 1px solid #eef4fd;
    font-size: 2.2rem;
    color: #141823;
    text-transform : uppercase;
    font-family: ${props.theme.font.fontFamily};
    font-weight: 600;
`,
);
export const PopupContent = styled.div`
  padding: 2rem;
`;

export const PopupClose = styled.div`
  padding: 1rem;
  display: flex;
  align-items: flex-end;
  cursor: pointer;
  
`
